export default __webpack_public_path__ + "static/media/appgallery-es.1f3c399d.png";